import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DropdownDTO } from "../../../types/common/DropdownDTO";

export interface IClientProfileDropdownState {
  clientProfileDropdown: DropdownDTO[];
}

export const initialState: IClientProfileDropdownState = {
  clientProfileDropdown: [],
};

export const clientProfileDropdownSlice = createSlice({
  name: "clientProfileDropdown",
  initialState,
  reducers: {
    loadingClientProfileDropdown: (state, action: PayloadAction<DropdownDTO[]>) => {
      state.clientProfileDropdown = action.payload;
    },
  },
});

export const { loadingClientProfileDropdown } = clientProfileDropdownSlice.actions;

export default clientProfileDropdownSlice.reducer;
